module.exports = __webpack_public_path__ + "img/mailouts-mailbox-error.4f643674.svg";